import React, { useState } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { Form, Input, Modal, Tooltip, notification } from 'antd'
import { useRecoilState } from 'recoil'
import { manageDeviceError } from '../../../../../../config/Recoil'
import { DelReportDeviceError } from '../../../../../../api/Device'

const Cancel = ({ deviceInfo }) => {
    const [visible, setVisible] = useState(false)
    const [getLinkUser, setLinkUser] = useRecoilState(manageDeviceError)
    const [form] = Form.useForm()
    const openModal = ()=>{
        setVisible(true)
    }
    const onOk = () => {
        form.submit()
    }
    const onCancel = () => {
        setVisible(false)
    }
    const onFinish = (elements)=>{
        DelReportDeviceError({
            RowID: deviceInfo.RowID,
            DeviceID: deviceInfo.DeviceId,
            Note: elements.Note,
            DocumentID: deviceInfo.DocumentID
        }).then(res => {
            if(res.RespCode === 0){
                notification.success('Đã hủy phiếu thiết bị thành công')
                setVisible(false)
                setLinkUser(!getLinkUser)
            }
        })
    }
    return (
        <div>
            <Modal visible={visible} onOk={onOk} onCancel={onCancel} title="Hủy phiếu báo hỏng">
                <Form form={form} onFinish={onFinish}>
                    <Form.Item name="Note" label="Lý do" rules={[{
                        required: true,
                        message: 'Hãy nhập lý do'
                    }]}>
                        <Input.TextArea/>
                    </Form.Item>
                </Form>
            </Modal>
            <Tooltip placement='bottom' title="Xóa phiếu báo hỏng">
                <DeleteOutlined onClick={openModal} style={{ fontSize: 20, color: 'red' }}/>
            </Tooltip>
        </div>
    )
}

export default Cancel